import { put, call, take, fork } from 'redux-saga/effects';
import { generateQuizWithCourseDocumentService } from '../../api/assignment';
//import { questionPatchSuccess } from '../../reducers/question/action'
import { generateQuizWithCourseDocumentSuccess } from '../../reducers/assignment/action';
import { GENERATE_QUIZ_WITH_COURSE_DOCUMENT } from '../../reducers/assignment/type';
import generalSaga from '../general';
import { operationSuccess, operationFail } from '../../reducers/operation/action';

/**
 *
 * @param {*} payload
 */
function* generateQuizWithCourseDocumentFlow(payload) {
  try {
    const { entity, callback } = payload;
    const response = yield call(generateQuizWithCourseDocumentService, entity);

    yield put(operationSuccess());
    yield put(generateQuizWithCourseDocumentSuccess(response.data));
    callback(response.data);
  } catch (error) {
    yield put(operationFail(error));
  }
}

/**
 *
 */
export default function* generateQuizWithCourseDocumentWatcher() {
  while (true) {
    const action = yield take(GENERATE_QUIZ_WITH_COURSE_DOCUMENT);
    const { payload } = action;

    yield fork(generalSaga, generateQuizWithCourseDocumentFlow, payload);
  }
}
